var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _c(
        "v-btn",
        { attrs: { icon: "" }, on: { click: _vm.toggleView } },
        [_c("v-icon", [_vm._v(_vm._s(_vm.toggleViewIcon))])],
        1
      ),
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      { attrs: { icon: "" }, on: { click: _vm.mostraOpzioni } },
                      on
                    ),
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            color: _vm.filtriApplicati ? "green" : undefined,
                          },
                        },
                        [_vm._v("mdi-file-find")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v("Filtri")])]
      ),
      _vm.bottoneAzioniVisibile
        ? _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            {
                              attrs: { icon: "" },
                              on: { click: _vm.mostraAzioni },
                            },
                            on
                          ),
                          [_c("v-icon", [_vm._v("cloud_upload")])],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1644325070
              ),
            },
            [_c("span", [_vm._v("Azioni disponibili")])]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }